import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UpdateDetailsComponent } from './update-details.component';

@NgModule({
   declarations: [UpdateDetailsComponent],
   exports: [UpdateDetailsComponent],
   imports: [CommonModule, RouterModule],
})
export class UpdateDetailsModule {}
